import { Box, Button, Dialog } from '@mui/material'
import { Grid } from '@mui/material'
import { get, isEmpty } from 'es-toolkit/compat'

import type { AppState } from 'state/index'

import type { Tenant } from 'state/account'
import { useTranslation } from 'react-i18next'

import { closeModal } from 'actions/app'
import { useAuth0 } from '@auth0/auth0-react'
import { useDispatch, useSelector } from 'react-redux'
import logo from 'images/farmtrx-logo.png'

import { clearIntegrationData } from 'common/integrationUtils'

export default function AccountImproperConfig() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { logout } = useAuth0()

  const handleLogout = () => {
    dispatch(closeModal())
    clearIntegrationData()
    sessionStorage.clear()
    //Remove the CFF localStorage items
    localStorage.removeItem('selectedClient')
    localStorage.removeItem('selectedFarms')
    //End
    logout({ logoutParams: { returnTo: window.location.origin } })
  }
  const partner: Tenant = useSelector((state) =>
    get(state as AppState, 'account.partnerContactDetails'),
  )

  let partnerName: string | undefined = 'FarmTRX'
  let partnerEmail: string | undefined = 'support@farmtrx.com'
  if (!isEmpty(partner)) {
    partnerName = partner.fullName
    partnerEmail = partner.email
  }

  return (
    <Dialog open={true}>
      <Box
        sx={{
          px: 3,
          py: 4,
          display: 'flex',
          maxHeight: '70vh',
          margin: 'auto',
          overflowY: 'auto',
          padding: '2rem',
          maxWidth: '60vw',
          alignItems: 'center',
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{
            alignItems: 'center',
          }}
        >
          <Grid size={{ xs: 12 }}>
            <img width="160" height="30" src={logo} />
          </Grid>
          <Grid size={{ xs: 12 }}>
            {t('account_improper_config', { partner_name: partnerName })}
          </Grid>
          <Grid size={{ xs: 12 }}>
            {t('email')}: {partnerEmail}
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Button variant="contained" color="primary" onClick={handleLogout}>
              {t('logout')}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  )
}
